import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6a8e0017"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "height": "80vh",
    "overflow-y": "scroll",
    "width": "48vw"
  },
  ref: "ticketFormBody"
};
const _hoisted_2 = {
  style: {},
  ref: "ticketFormHeader"
};
const _hoisted_3 = {
  style: {
    "text-align": "center",
    "font-size": "18px",
    "font-weight": "blod",
    "width": "75%",
    "margin-left": "110px",
    "word-wrap": "break-word",
    "margin-bottom": "50px"
  }
};
const _hoisted_4 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};
const _hoisted_5 = {
  style: {
    "line-height": "20px",
    "white-space": "nowrap"
  }
};
const _hoisted_6 = {
  style: {
    "color": "rgb(126, 127, 134)",
    "line-height": "20px",
    "word-break": "break-all"
  }
};
const _hoisted_7 = {
  style: {
    "display": "block"
  }
};
const _hoisted_8 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto",
    "margin-bottom": "25px"
  }
};
const _hoisted_9 = {
  class: "itemEn",
  style: {
    "color": "rgb(217,0,27)",
    "font-weight": "bold",
    "font-size": "15px"
  }
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "itemEn"
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "itemEn",
  style: {
    "text-align": "center"
  }
}, null, -1));

const _hoisted_12 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};
const _hoisted_13 = {
  class: "itemEnC",
  style: {
    "height": "30px"
  }
};
const _hoisted_14 = {
  class: "itemEnContent content"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto",
    "height": "30px"
  }
};
const _hoisted_17 = {
  class: "itemEnC",
  style: {
    "height": "30px"
  }
};
const _hoisted_18 = {
  class: "itemEnC content"
};
const _hoisted_19 = {
  class: "itemEnC",
  style: {
    "height": "30px",
    "text-align": "center"
  }
};
const _hoisted_20 = {
  class: "itemEnC content"
};
const _hoisted_21 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto",
    "height": "30px"
  }
};
const _hoisted_22 = {
  class: "itemEnC",
  style: {
    "height": "30px"
  }
};
const _hoisted_23 = {
  class: "itemEnC content"
};
const _hoisted_24 = {
  class: "itemEnC",
  style: {
    "height": "30px",
    "text-align": "center"
  }
};
const _hoisted_25 = {
  class: "itemEnC content"
};
const _hoisted_26 = {
  style: {
    "width": "90%",
    "display": "flex",
    "margin": "0 auto"
  }
};
const _hoisted_27 = {
  class: "itemEnC",
  style: {
    "height": "30px"
  }
};
const _hoisted_28 = {
  class: "itemEnContent content"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_31 = {
  style: {
    "width": "90%"
  }
};
const _hoisted_32 = {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "margin-bottom": "15px"
  }
};
const _hoisted_33 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_34 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_35 = {
  key: 0,
  class: "content",
  style: {
    "margin-left": "20px",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_36 = {
  key: 1,
  class: "content",
  style: {
    "margin-left": "20px",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_37 = {
  key: 1
};
const _hoisted_38 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_39 = {
  style: {
    "width": "90%"
  }
};
const _hoisted_40 = {
  style: {
    "font-size": "14px",
    "font-weight": "bold",
    "margin-bottom": "30px"
  }
};
const _hoisted_41 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_42 = {
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_43 = {
  class: "content",
  style: {
    "margin-left": "10px",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_44 = {
  key: 0,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "20px"
  }
};
const _hoisted_45 = {
  key: 1,
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin-top": "20px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_icon_Close = _resolveComponent("el-icon-Close");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_templateInit = _resolveComponent("templateInit");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_tabs = _resolveComponent("el-tabs");

  const _component_el_main = _resolveComponent("el-main");

  const _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createBlock(_component_el_container, {
    style: {
      "width": "50vw"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_main, null, {
      default: _withCtx(() => [_createVNode(_component_el_tabs, {
        type: "border-card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 20,
          style: {
            "cursor": "pointer",
            "float": "right"
          },
          onClick: $options.returnPreView
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon_Close)]),
          _: 1
        }, 8, ["onClick"]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($props.dpt.status != '1' && $props.userView ? $data.damageRTextL.view : "") + " " + _toDisplayString($props.dpt.tempItemName) + "-" + _toDisplayString($props.dpt.statusName), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.damageRTextL.problemPhenomenon) + "： ", 1), _createElementVNode("div", _hoisted_6, _toDisplayString($props.dpt.problemPhenomenon || '--'), 1)]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($data.damageRTextL.basicInformation), 1), _createElementVNode("div", {
          class: "itemEn",
          style: {
            "font-weight": "bold",
            "font-size": "15px",
            "cursor": "pointer",
            "min-width": "190px"
          },
          onClick: _cache[0] || (_cache[0] = (...args) => $options.teleport && $options.teleport(...args))
        }, _toDisplayString($data.damageRTextL.fillInTheDamageReport), 1), _hoisted_10, _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($data.damageRTextL.productPurchaseChannel) + "： ", 1), _createElementVNode("div", _hoisted_14, _toDisplayString($props.dpt.purchasingChannelsName), 1)]), $props.dpt.purchasingChannels === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString($data.damageRTextL.orderNumber) + "： ", 1), _createElementVNode("div", _hoisted_18, _toDisplayString($props.dpt.orderNum), 1), _createElementVNode("div", _hoisted_19, _toDisplayString($data.damageRTextL.shippingWarehouse) + "： ", 1), _createElementVNode("div", _hoisted_20, _toDisplayString($props.dpt.deliveryWarehouseName), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString($data.damageRTextL.paymentTime) + "： ", 1), _createElementVNode("div", _hoisted_23, _toDisplayString($props.dpt.paymentTime ? $props.dpt.paymentTime : ""), 1), _createElementVNode("div", _hoisted_24, _toDisplayString($data.damageRTextL.warrantyStatus) + "： ", 1), _createElementVNode("div", _hoisted_25, _toDisplayString($props.dpt.warrantyTypeName), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString($data.damageRTextL.shopName) + "： ", 1), _createElementVNode("div", _hoisted_28, _toDisplayString($props.dpt.shopName || '--'), 1)])]), _createVNode(_component_el_divider)], 512), _createElementVNode("div", null, [_createElementVNode("div", {
          style: {
            "margin": "20px 50px",
            "font-weight": "bold",
            "font-size": "15px"
          },
          ref: "dptEdit"
        }, _toDisplayString($data.damageRTextL.fillInTheDamageReport), 513)]), _createVNode(_component_templateInit, {
          tempItemContentList: $props.dpt.tempItemContentList,
          languageType: $props.dpt.languageType,
          status: $props.dpt.status,
          isAdmin: false,
          isView: $data.userIsView,
          statusName: $props.dpt.statusName,
          damageRTextL: $data.damageRTextL,
          sortTemplateData: $options.sortTemplateData,
          ref: "templateInit"
        }, null, 8, ["tempItemContentList", "languageType", "status", "isView", "statusName", "damageRTextL", "sortTemplateData"]), (this.dpt.status === '3' || this.dpt.status === '4') && $props.userView ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString($data.damageRTextL.reviewConclusion), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString($data.damageRTextL.processingPlan), 1), $props.dpt.checkConclusionStatus === '6' ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($props.dpt.checkConclusionRemark), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString($props.dpt.checkConclusionStatusName), 1))])])]), _createVNode(_component_el_divider)])) : _createCommentVNode("", true), this.dpt.status === '5' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString($data.damageRTextL.voids) + ": ", 1), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString($data.damageRTextL.voidReason) + ": ", 1), _createElementVNode("div", _hoisted_43, _toDisplayString($props.dpt.abandonCause), 1)])])]), _createVNode(_component_el_divider)])) : _createCommentVNode("", true)], 512), ($props.dpt.status === '1' || $props.dpt.status === '3') && !$props.userView ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createVNode(_component_el_button, {
          style: {
            "width": "120px",
            "background-color": "rgba(255, 245,245)",
            "border": "1px solid rgba(210,0,47)",
            "color": "rgba(210,0,47)"
          },
          onClick: $options.cancel
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.damageRTextL.cancel), 1)]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          style: {
            "width": "120px",
            "margin-left": "30px",
            "background-color": "rgba(210,0,47)",
            "color": "white"
          },
          onClick: $options.nextStep
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.damageRTextL.submit), 1)]),
          _: 1
        }, 8, ["onClick"])])) : (_openBlock(), _createElementBlock("div", _hoisted_45, [_createVNode(_component_el_button, {
          style: {
            "width": "120px",
            "margin-left": "30px",
            "background-color": "rgba(210,0,47)",
            "color": "white"
          },
          onClick: $options.cancel
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.damageRTextL.back), 1)]),
          _: 1
        }, 8, ["onClick"])]))])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}